<template>
  <div>
    <div @click="cancel" class="vm--overlay"></div>
    <div class="new-chore-form-body">
      <div class="new-chore-title-container">
        <label class="new-chore-title"> {{ title }}</label>
      </div>

      <div class="new-chore-label-container">
        <label class="new-chore-field-label">Name of the chore</label>
        <label class="new-chore-error-label" v-if="invalidator['name'] == true">
          * missing
        </label>
      </div>
      <input
        placeholder="E.g Wash dishes"
        type="text"
        class="new-chore-name-input"
        v-model="inputName"
      />

      <div class="new-chore-label-container">
        <label class="new-chore-field-label">Property</label>
        <label
          class="new-chore-error-label"
          v-if="invalidator['property'] == true"
        >
          * missing
        </label>
      </div>
      <select
        class="new-chore-select-property-input"
        v-model="selectedProperty"
        :disabled="edit"
      >
        <option selected :value="null">Select Property</option>
        <option
          v-for="property of properties"
          :key="'property-' + property.uuid"
          :value="property"
        >
          {{ property.internalName }}
        </option>
      </select>

      <div class="new-chore-label-container">
        <label class="new-chore-field-label">Description (Optional) </label>
      </div>
      <input
        placeholder="Write a description of the chore"
        type="text"
        class="new-chore-name-input"
        v-model="inputDescription"
      />

      <div class="new-chore-recurrence-container">
        <div class="new-chore-recurrence-type-container">
          <label class="new-chore-recurrence-label">Frequency</label>
          <div class="new-chore-recurrence-buttons-subcontainer">
            <button
              v-for="type of types"
              class="new-chore-type-button"
              :class="{
                'new-chore-button-selected': selectedType == type ? true : false
              }"
              :key="type"
              @click="selType(type)"
            >
              {{ type }}
            </button>
          </div>
        </div>

        <div class="new-chore-recurrence-day-container">
          <div class="new-chore-recurrence-label-container">
            <label
              class="new-chore-error-label"
              v-if="invalidator['recurrence'] == true"
            >
              * missing
            </label>
          </div>
          <div class="new-chore-recurrence-buttons-subcontainer">
            <button
              v-for="day in days"
              class="new-chore-day-button"
              :class="{
                'new-chore-button-selected': selectedDays[day] ? true : false
              }"
              :key="day"
              @click="selDay(day)"
            >
              {{ day }}
            </button>
          </div>
        </div>
      </div>
      <div class="new-chore-buttons-container">
        <button @click="cancel" class="new-chore-cancel-button">
          {{ cancelText }}
        </button>
        <button @click="save" class="new-chore-create-button">
          {{ buttonText }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import calls from '@/api/calls.js'
import Property from '@/models/property.js'

const daysArrMap = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

export default {
  props: {
    selTask: null
  },
  data() {
    return {
      title: 'New Chore',
      buttonText: 'Create Chore',
      cancelText: 'Cancel',
      types: ['Daily', 'Weekly'],
      days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      selectedDays: {
        Sun: false,
        Mon: false,
        Tue: false,
        Wed: false,
        Thu: false,
        Fri: false,
        Sat: false
      },
      selectedType: 'Weekly',
      properties: [],
      selectedProperty: null,
      inputName: null,
      inputDescription: null,
      invalidator: {
        name: false,
        property: [false],
        recurrence: false
      },
      recurreceContainerKey: 0,
      edit: false
    }
  },
  methods: {
    async loadSelectedTask() {
      if (this.selTask) {
        this.edit = true
        this.title = 'Edit Chore'
        this.buttonText = 'Save Changes'
        this.cancelText = 'Close'
        const chore = this.selTask
        const { message, data } = await calls.GET(
          'chores/property/from',
          chore.uuid
        )
        this.selectedProperty = this.properties.find((e) => e.uuid == data.uuid)
        this.inputName = chore.name
        this.selectedType = chore.type
        for (let index in chore.recurrence) {
          const value = chore.recurrence[index]
          this.selectedDays[daysArrMap[index]] = value
        }
        if (chore.description) {
          this.inputDescription = chore.description
        }
      }
    },
    async loadProperties() {
      const { message, data } = await calls.GET('properties')
      for (const datum of data) {
        this.properties.push(
          new Property(
            datum.uuid,
            datum.internalName,
            datum.marketingName,
            datum.country,
            datum.state,
            datum.city,
            datum.address,
            datum.zipcode,
            { ...datum }
          )
        )
      }
    },
    selType(type) {
      if (this.selectedType == type || this.edit) return
      for (const day of this.days) {
        this.selectedDays[day] = type == 'Daily'
      }
      this.selectedType = type
    },
    selDay(day) {
      if (this.selectedType == 'Daily' || this.edit) return
      if (this.selectedDays[day]) {
        this.selectedDays[day] = false
      } else {
        this.selectedDays[day] = true
      }
      this.recurreceContainerKey += 1
    },
    cancel() {
      this.$emit('cancel')
    },
    async save() {
      let needsToReturn = false
      if (this.inputName == null || this.inputName.trim() == '') {
        this.invalidator['name'] = true
        needsToReturn = true
      }

      if (this.selectedProperty == null) {
        this.invalidator['property'] = true
        needsToReturn = true
      }

      let allDaysUnselected = true
      if (this.selectedType == 'Weekly') {
        const selectedDays = Object.values(this.selectedDays)
        for (const day of selectedDays) {
          if (day) {
            allDaysUnselected = false
          }
        }
        if (allDaysUnselected) {
          this.invalidator['recurrence'] = true
          needsToReturn = true
        }
      }

      if (needsToReturn) {
        await this.$forceUpdate()
        return
      }

      let cronDays = []
      const daysKeys = Object.keys(this.selectedDays)
      for (let index = 0; index < 7; index++) {
        let dictKey = daysKeys[index]
        if (this.selectedDays[dictKey]) cronDays.push(dictKey)
      }
      const cronWeeklyFormat = '* * * * ' + cronDays.join(',')
      const schedule =
        this.selectedType == 'Daily' ? '* * * * *' : cronWeeklyFormat
      let newChoreID
      {
        //create or update the chore
        const { message, error, data } = this.selTask
          ? await calls.PUT('chores', this.selTask.uuid, {
              name: this.inputName,
              description: this.inputDescription ? this.inputDescription : ' '
            })
          : await calls.POST('chores', {
              name: this.inputName,
              schedule,
              description: this.inputDescription ? this.inputDescription : ' '
            })
        newChoreID = data.uuid
        if (error) {
          if (message) {
            this.$notify({
              group: 'rent-mgt-notification',
              type: 'error',
              text: message
            })
          }
          return
        }
      }
      {
        //change where the property belongs
        const { message, error } = this.selTask
          ? await calls.PUT(
              'properties/switch',
              `${this.selectedProperty.uuid}/${this.selTask.uuid}`
            )
          : await calls.PUT(
              'properties/set',
              `${this.selectedProperty.uuid}/${newChoreID}`
            )
        if (error) {
          if (message) {
            this.$notify({
              group: 'rent-mgt-notification',
              type: 'error',
              text: message
            })
          }
          return
        }
      }

      {
        //assign a new date
        const { message, data, data2 } = this.selTask
          ? await calls.POST(`assignment/autoredate/${this.selTask.uuid}`, {
              schedule
            })
          : await calls.POST(`assignment/autoassign/${newChoreID}`)
        if (message) {
          this.$notify({
            group: 'rent-mgt-notification',
            type: 'error',
            text: message
          })
        }
      }
      this.$emit('save-create')
    }
  },
  async beforeMount() {
    this.$emit('loading', true)
    try {
      await this.loadProperties()
      await this.loadSelectedTask()
    } finally {
      this.$emit('loading', false)
    }
  }
}
</script>

<style scoped>
.no-editing {
  text-align: center;
  margin-top: 20px;
  padding-top: 12px;
  padding-bottom: 12px;
  width: 100%;
  color: #d2732a;
  background: #faf0e6;
  border-radius: 6px;
}
.new-chore-background {
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  border-radius: 0px;
  margin: 0;
  padding: 0;
  z-index: 2;
}
.new-chore-form-body {
  background: white;
  position: absolute;
  top: calc(50% - 239px);
  left: calc(50% - 254px);
  width: 508px;
  border-radius: 4px;
  display: flex;
  flex-flow: column nowrap;
  margin: 0;
  padding: 30px 24px;
}

.new-chore-title-container {
  margin: 0;
  padding: 0;
  display: flex;
  flex-flow: row nowrap;
  justify-content: left;
  margin-bottom: 10px;
}

.new-chore-title {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 22px;
  color: #66b015;
}

.new-chore-name-input,
.new-chore-select-property-input,
.new-chore-add-property-container {
  margin-bottom: 10px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  /* line-height: 40px; */
  display: flex;
  align-items: center;
  color: #767675;
  cursor: pointer;
  margin-top: 5px;
}

.new-chore-label-container {
  display: flex;
  flex-flow: row nowrap;
  margin-top: 15px;
}

.new-chore-field-label {
  font-family: Montserrat;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: left;
  cursor: pointer;
}

.new-chore-error-label {
  color: rgba(255, 0, 0, 100);
  margin-left: 10px;
}

.new-chore-name-input {
  width: 100%;
  border: 1px solid #cbd4dc;
  box-sizing: border-box;
  border-radius: 5px;
  outline: none;
  padding-left: 8px;
}

.new-chore-select-property-container {
  display: flex;
  flex-flow: column nowrap;
}

.new-chore-select-property-input {
  width: 100%;
  border: 1px solid #cbd4dc;
  box-sizing: border-box;
  border-radius: 5px;
  outline: none;
  color: rgb(118, 118, 117);
  padding-left: 8px;
}

.new-chore-add-property-container {
  margin-top: 14px;
  display: flex;
  flex-flow: row nowrap;
  margin-right: 60%;
  width: 218px;
  height: 32px;
}

.new-chore-add-button-background {
  height: 22px;
  width: 22px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  background: rgb(102, 176, 21);
  margin-right: 10px;
}
.new-chore-add-button-background:active {
  background: rgb(60, 107, 9);
}
.new-chore-add-button-background:hover {
  cursor: pointer;
}

.new-chore-add-button-text {
  color: white;
  font-weight: bolder;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  font-size: 18px;
}

.new-chore-add-button-label {
  margin-top: 3px;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: left;
}

.new-chore-recurrence-container {
  margin-top: 17px;
  display: flex;
  flex-flow: row nowrap;
  align-content: center;
  justify-content: space-between;
}

.new-chore-recurrence-label-container {
  display: flex;
  flex-flow: row nowrap;
}

.new-chore-recurrence-label {
  text-align: left;
  height: 15px;
  border-radius: nullpx;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 15px;
  color: #192a3e;
}

.new-chore-recurrence-type-container,
.new-chore-recurrence-day-container {
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-content: left;
  height: 65px;
}

.new-chore-recurrence-type-container {
  width: 40%;
  margin-right: 5px;
  cursor: pointer;
}

.new-chore-recurrence-day-container {
  width: 60%;
  margin-left: 5px;
  cursor: pointer;
}

.new-chore-recurrence-buttons-subcontainer {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  align-content: center;
  width: 100%;
}

.new-chore-day-button,
.new-chore-type-button {
  height: 40px;
  flex-grow: 1;
  border-radius: 4px;
  border: 1px solid #cbd4dc;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 0;
  background: white;

  font-family: Montserrat;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: center;
  color: rgb(118, 118, 117);
  outline: none;
}

.new-chore-type-button {
  margin: 0 2px 0 2px;
  cursor: pointer;
}

.new-chore-day-button {
  margin-left: 1px;
  width: 34px;
  cursor: pointer;
}

.new-chore-buttons-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-evenly;
  align-items: right;
  margin-top: 32px;
}

.new-chore-cancel-button:hover,
.new-chore-create-button:hover {
  cursor: pointer;
}

.new-chore-cancel-button,
.new-chore-create-button {
  width: 190px;
  outline: none;
  height: 48px;
}

.new-chore-cancel-button {
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: center;
  color: rgb(118, 118, 117);

  background: #ffffff;
  border: 1px solid #767675;
  border-radius: 4px;
}

.new-chore-create-button {
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: center;
  color: rgb(255, 255, 255, 1);

  background: #66b015;
  border: 1px solid #66b015;
  border-radius: 4px;
}
.new-chore-create-button:hover {
  cursor: pointer;
}
.new-chore-create-button:focus {
  background: rgb(60, 107, 9);
}

.new-chore-button-selected {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 900;
  font-size: 10px;
  line-height: 14px;
  color: var(--rentalios-dark);

  background: #ebf0e6;
  border: none;
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
  .new-chore-form-body {
    position: fixed;
    top: 5%;
    left: 5%;
    right: 5%;
    width: 90%;
    height: auto;
    max-height: 90vh;
    overflow-y: auto;
    transform: none;
    padding: 20px;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  }

  .new-chore-title-container {
    margin-bottom: 16px;
    position: sticky;
    top: 0;
    background: white;
    padding: 16px 0;
    z-index: 100;
    border-bottom: 1px solid #f0f0f0;
    margin-top: -20px;
    margin-left: -20px;
    margin-right: -20px;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 20px;
    padding-bottom: 16px;
  }

  .new-chore-title {
    font-size: 18px;
    line-height: 24px;
    font-weight: 900;
    margin: 0;
    padding: 0;
  }

  .new-chore-label-container {
    margin-top: 16px;
    flex-direction: column;
    gap: 6px;
  }

  .new-chore-field-label {
    font-size: 13px;
    line-height: 16px;
    font-weight: 600;
    color: #333;
  }

  .new-chore-error-label {
    margin-left: 0;
    margin-top: 4px;
    color: #e74c3c;
    font-size: 11px;
  }

  .new-chore-name-input,
  .new-chore-select-property-input {
    height: 44px;
    font-size: 16px;
    margin-top: 6px;
    margin-bottom: 12px;
    padding: 10px 14px;
    border-radius: 8px;
    border: 2px solid #e1e5e9;
    transition: border-color 0.2s ease;
  }

  .new-chore-name-input:focus,
  .new-chore-select-property-input:focus {
    border-color: #66b015;
    outline: none;
    box-shadow: 0 0 0 3px rgba(102, 176, 21, 0.1);
  }

  .new-chore-recurrence-container {
    flex-direction: column;
    gap: 20px;
    margin-top: 20px;
    background: #f8f9fa;
    padding: 16px;
    border-radius: 8px;
  }

  .new-chore-recurrence-type-container,
  .new-chore-recurrence-day-container {
    width: 100%;
    margin: 0;
    height: auto;
  }

  .new-chore-recurrence-label {
    font-size: 13px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
  }

  .new-chore-recurrence-buttons-subcontainer {
    gap: 6px;
    margin-top: 10px;
    flex-wrap: wrap;
  }

  .new-chore-type-button,
  .new-chore-day-button {
    height: 42px;
    font-size: 12px;
    line-height: 14px;
    flex: 1;
    min-width: 50px;
    border-radius: 6px;
    border: 2px solid #e1e5e9;
    transition: all 0.2s ease;
    font-weight: 500;
  }

  .new-chore-type-button:hover,
  .new-chore-day-button:hover {
    border-color: #66b015;
    background-color: #f8f9fa;
  }

  .new-chore-day-button {
    width: auto;
    margin-left: 0;
    min-width: 35px;
  }

  .new-chore-buttons-container {
    flex-direction: column;
    gap: 10px;
    margin-top: 24px;
    position: sticky;
    bottom: 0;
    background: white;
    padding: 16px 0;
    border-top: 2px solid #f0f0f0;
    margin-left: -20px;
    margin-right: -20px;
    padding-left: 20px;
    padding-right: 20px;
  }

  .new-chore-cancel-button,
  .new-chore-create-button {
    width: 100%;
    height: 44px;
    font-size: 15px;
    border-radius: 8px;
    font-weight: 600;
    transition: all 0.2s ease;
  }

  .new-chore-cancel-button {
    border: 2px solid #e1e5e9;
    background: white;
    color: #666;
  }

  .new-chore-cancel-button:hover {
    border-color: #66b015;
    color: #66b015;
  }

  .new-chore-create-button {
    background: #66b015;
    border: 2px solid #66b015;
    color: white;
  }

  .new-chore-create-button:hover {
    background: #5a9b12;
    border-color: #5a9b12;
    transform: translateY(-1px);
  }

  .new-chore-add-property-container {
    margin-right: 0;
    width: 100%;
    height: 44px;
  }

  .new-chore-add-button-background {
    height: 28px;
    width: 28px;
  }

  /* Enhanced scrolling experience */
  .new-chore-form-body::-webkit-scrollbar {
    width: 6px;
  }

  .new-chore-form-body::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  .new-chore-form-body::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  .new-chore-form-body::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  /* Ensure proper focus states */
  .new-chore-form-body:focus-within {
    outline: none;
  }

  /* Mobile-specific touch improvements */
  .new-chore-type-button:active,
  .new-chore-day-button:active {
    transform: scale(0.98);
    transition: transform 0.1s ease;
  }

  .new-chore-create-button:active {
    transform: scale(0.98) translateY(0);
  }

  /* Prevent zoom on iOS */
  .new-chore-name-input,
  .new-chore-select-property-input {
    font-size: 16px;
  }

  /* Better mobile spacing */
  .new-chore-form-body
    > *:not(.new-chore-title-container):not(.new-chore-buttons-container) {
    margin-bottom: 16px;
  }

  /* Enhanced mobile accessibility */
  .new-chore-field-label {
    cursor: pointer;
    user-select: none;
  }

  /* Mobile-optimized select styling */
  .new-chore-select-property-input {
    appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 16px;
    padding-right: 40px;
  }
}

@media (max-width: 480px) {
  .new-chore-form-body {
    top: 10%;
    left: 0%;
    right: 0%;
    width: 91%;
    max-height: 96vh;
    padding: 18px;
    overflow-y: auto;
    border-radius: 6px;
  }

  .new-chore-title-container {
    padding: 12px 0;
    margin-bottom: 14px;
    margin-top: -18px;
    margin-left: -18px;
    margin-right: -18px;
    padding-left: 18px;
    padding-right: 18px;
    padding-top: 18px;
    padding-bottom: 14px;
  }

  .new-chore-title {
    font-size: 16px;
    line-height: 22px;
  }

  .new-chore-label-container {
    margin-top: 14px;
    gap: 5px;
  }

  .new-chore-field-label {
    font-size: 12px;
    line-height: 15px;
  }

  .new-chore-name-input,
  .new-chore-select-property-input {
    height: 40px;
    font-size: 16px;
    margin-top: 5px;
    margin-bottom: 10px;
    padding: 8px 12px;
    border-radius: 6px;
  }

  .new-chore-recurrence-container {
    gap: 16px;
    margin-top: 16px;
    padding: 14px;
    border-radius: 6px;
  }

  .new-chore-recurrence-label {
    font-size: 12px;
    margin-bottom: 8px;
  }

  .new-chore-recurrence-buttons-subcontainer {
    gap: 4px;
    margin-top: 8px;
  }

  .new-chore-type-button,
  .new-chore-day-button {
    height: 38px;
    font-size: 11px;
    line-height: 13px;
    min-width: 45px;
    border-radius: 5px;
  }

  .new-chore-day-button {
    min-width: 30px;
  }

  .new-chore-buttons-container {
    gap: 8px;
    margin-top: 0px;
    padding: 12px 0;
    margin-left: -18px;
    margin-right: -18px;
    padding-left: 18px;
    padding-right: 18px;
  }

  .new-chore-cancel-button,
  .new-chore-create-button {
    height: 40px;
    font-size: 13px;
    border-radius: 6px;
    width: 96%;
    margin: auto;
  }

  .new-chore-add-property-container {
    height: 40px;
  }

  .new-chore-add-button-background {
    height: 24px;
    width: 24px;
  }
}
</style>
